import React from 'react';
import { reloadPage } from '../../core/appLocation/index.js';
export const Reload = () => {
    React.useEffect(() => {
        reloadPage();
    });
    return null;
};
//# sourceMappingURL=index.js.map